import React from 'react';
import { useSelector } from 'react-redux';
// import { defineMessages } from 'react-intl';
import {
  Divider,
  Drawer,
  List,
  ListItem,
  ListItemText,
  ListItemIcon,
} from '@material-ui/core';
import Close from '@material-ui/icons/Close';

import styles from './styles.module.css';
import ChartControlSheet from '../../pages/chart-controls/ChartControlSheet';

// localization
// eslint-disable-next-line
// const messages = defineMessages({
//   NEW_CARD: {
//     id: 'NEW_CARD',
//     defaultMessage: 'New Card',
//   },
// });

const RightSidebar = ({ toggleSidebar }) => {
  const layout = useSelector((state) => state?.layout);
  const selectedChartId = useSelector((state) => state?.board?.selectedChartId);

  return (
    <>
      <Drawer
        open={layout.showRightSidebar}
        anchor="right"
        classes={{
          paper: `${styles.sideBar} ${styles.sideSheetsPosition}`,
          modal: styles.sideSheetsModal,
        }}
        hideBackdrop
      >
        <div className={styles.list}>
          {!layout?.editMode && (
            <>
              <List dense className={styles.menu}>
                <ListItem button>
                  <ListItemIcon>
                    <Close onClick={() => toggleSidebar('right', false)} />
                  </ListItemIcon>

                  <ListItemText primary="New Card" />
                </ListItem>
              </List>

              <Divider />
            </>
          )}

          { selectedChartId && <ChartControlSheet /> }
        </div>
      </Drawer>
    </>
  );
};

export default RightSidebar;
